import React from 'react'
import { Dropdown } from 'react-bootstrap'
import styles from '../../UpdateSiteModal.module.css'

export const Toggle = ({ checked, onChange, id, ariaLabel }) => {
  return (
    <label className={styles.switch} htmlFor={id}>
      <input type="checkbox" checked={checked} onChange={onChange} id={id} aria-label={ariaLabel} />
      <span className={`${styles.slider} ${styles.sliderRound}`}></span>
    </label>
  )
}

export const AccessOption = ({ iconClass, iconSrc, iconContent, title, description, control }) => {
  return (
    <div className={styles.accessOptionWrapper}>
      <div className={styles.accessOption}>
        <div className={`${styles.optionIcon} ${styles[iconClass]}`}>
          {iconSrc ? <img src={iconSrc} alt={title} height="24" width="24" className="op-6" /> : iconContent}
        </div>
        <div className={styles.optionDetails}>
          <div className={styles.optionTitle}>{title}</div>
          <div className={styles.optionDescription}>{description}</div>
        </div>
      </div>

      {control}
    </div>
  )
}

export const AccessModeDropdown = ({ value, onChange, options, checkFeatureAccess }) => {
  const selectedOption = options.find((option) => option.value === value)

  const handleSelect = (selectedValue) => {
    if (checkFeatureAccess && !checkFeatureAccess(selectedValue)) {
      return
    }
    onChange(selectedValue)
  }

  return (
    <Dropdown className={styles.accessModeDropdown}>
      <Dropdown.Toggle variant="outline-light" id="dropdown-access-mode" className={styles.accessModeToggle}>
        <span className={styles.accessModeDropdownLabel}>{selectedOption?.label}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu className={styles.accessModeMenu}>
        {options.map((option) => (
          <Dropdown.Item
            key={option.value}
            eventKey={option.value}
            active={value === option.value}
            onClick={() => handleSelect(option.value)}
            className={`dropdown-item ${styles.dropdownItem}`}
          >
            <div className={styles.dropdownItemContent}>
              <div>{option.label}</div>
              {option.description && <div className={styles.dropdownDescription}>{option.description}</div>}
            </div>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}
